class CourseService {
    constructor() {
        this.apiUrl = 'https://online.sparrowportal.co.za/moodle/webservice/rest/server.php?wstoken=463a4b4d3f40c05671e3dd73841fa4d0&wsfunction=core_course_get_courses&moodlewsrestformat=json';
        this.targetCategory = 10;
        this.specificCourseId = null; // Disabled to show all courses in category 10
    }

    async fetchCourses() {
        try {
            const response = await fetch(this.apiUrl);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.exception) {
                throw new Error(data.message || 'API Error occurred');
            }

            // Filter courses based on criteria
            const filteredCourses = this.filterCourses(data);
            return filteredCourses;

        } catch (error) {
            console.error('Error fetching courses:', error);
            throw error;
        }
    }

    filterCourses(allCourses) {
        // Option 1: Show only specific course ID 75
        if (this.specificCourseId) {
            return allCourses.filter(course => course.id === this.specificCourseId);
        }
        
        // Option 2: Show all courses from category 14
        return allCourses.filter(course => 
            course.categoryid === this.targetCategory && course.id !== 1
        );
    }

    stripHtml(html) {
        // Create a temporary div element to parse HTML
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const text = tmp.textContent || tmp.innerText || '';
        return text.length > 150 ? text.substring(0, 150) + '...' : text;
    }

    searchCourses(courses, searchTerm) {
        const term = searchTerm.toLowerCase();
        return courses.filter(course => 
            course.fullname.toLowerCase().includes(term) ||
            (course.summary && course.summary.toLowerCase().includes(term)) ||
            (course.shortname && course.shortname.toLowerCase().includes(term)) ||
            course.id.toString().includes(term)
        );
    }
}

const courseServiceInstance = new CourseService();
export default courseServiceInstance;
